import { Grid, StackProps } from '@mui/material'
import { FC } from 'react'
import { OrderItemCard } from 'components/ordering/OrderItemCard'
import { useOrdering } from 'hooks'

interface OrderItemsGridProps extends StackProps {
  readonly?: boolean
}

export const OrderItemsGrid: FC<OrderItemsGridProps> = ({
  readonly,
  ...props
}) => {
  const { order } = useOrdering()
  return (
    <Grid container spacing={2.5} rowSpacing={1.5} {...props}>
      {order?.items?.map((item) => (
        <Grid key={item.id} item lg={4} md={6} sm={12} xs={12}>
          <OrderItemCard orderItem={item} readonly={readonly} />
        </Grid>
      ))}
    </Grid>
  )
}
